import { api } from "./index";

export async function createUpload(image) {
  const presignedResponse = await api.get(
    "/partners/presigned_s3_url?random=" + Math.random(),
    {
      params: {
        contentType: "application/octet-stream",
      },
    },
  );
  const presignedData = presignedResponse.data;

  const uploadResponse = await fetch(presignedData.presigned_url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/octet-stream",
    },
    body: image,
  });

  if (!uploadResponse.ok) {
    const error = new Error(
      `Image Upload failed: ${uploadResponse.status} ${uploadResponse.statusText}`,
    );
    error.status = uploadResponse.status;
    error.response = uploadResponse;
    throw error;
  }

  return {
    data: {
      file_name: presignedData.presigned_url.split("?")[0].split("/").pop(),
    },
  };
}
